// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sales__title{max-width:250px}@media (max-width:1199px){.sales__title{max-width:none}}.sales__grid{display:grid;grid-template-columns:repeat(3,1fr)}@media (max-width:575px){.sales__grid{grid-template-columns:1fr;grid-gap:24px}}.sales__item strong{display:block;margin-bottom:24px;font-size:88px;line-height:70px;font-weight:400}@media (max-width:767px){.sales__item strong{margin-bottom:16px;font-size:48px;line-height:40px}}.sales__item--special strong{color:#eb4247}", ""]);
// Exports
module.exports = exports;
